import { Component, OnInit } from '@angular/core';
import {SurveyViewerService} from "../../../../app/modules/survey/survey-viewer/services/survey-viewer.service";
import {AsyncPipe, NgClass, NgForOf, NgIf} from "@angular/common";
import {TranslocoService} from "@ngneat/transloco";
import {
  SurveyQuestionComponent
} from "../../../../app/modules/survey/survey-viewer/survey-question/survey-question.component";

@Component({
    selector: 'app-test-survey-questions',
    standalone: true,
    templateUrl: './test-survey-questions.component.html',
    imports: [
        AsyncPipe,
        NgForOf,
        NgClass,
        NgIf,
        SurveyQuestionComponent
    ],
    styleUrls: ['./test-survey-questions.component.scss']
})
export class TestSurveyQuestionsComponent implements OnInit {

  constructor(
    public surveyViewerService: SurveyViewerService,
    public translateService: TranslocoService,
  ) { }

  ngOnInit(): void {
  }

}
